import { render, staticRenderFns } from "./all_chat.vue?vue&type=template&id=f73094ae&"
import script from "./all_chat.vue?vue&type=script&lang=js&"
export * from "./all_chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports